// 확인 메일 보낸 화면(서버는 발송 접수만 답한다 — 실제 발송은 응답 뒤) — 다시 보내기(60초 대기) · 메일 주소 바꾸기 · 스팸함 안내.

import { useTransition } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { resendSignupMail } from "@/api/actions/onboarding";
import { RESEND_COOLDOWN_SECONDS, RESEND_FAILED_MESSAGE, resendLabelOf, useResendCooldown } from "./signup-sent-state";

interface Props {
  email: string;
  onChangeEmail?: () => void;
  // 링크 만료 등으로 들어왔으면 대기 없이 바로 다시 보낼 수 있다.
  cooldown?: number;
}

const SignupSent = ({ email, onChangeEmail, cooldown = RESEND_COOLDOWN_SECONDS }: Props) => {
  const { left, restart } = useResendCooldown(cooldown);
  const [pending, startTransition] = useTransition();

  const resend = () =>
    startTransition(async () => {
      try {
        const result = await resendSignupMail(email);
        if (result.ok) toast.success(result.message);
        else toast.error(result.message);
        restart();
      } catch {
        toast.error(RESEND_FAILED_MESSAGE);
      }
    });

  return (
    <div className="flex flex-col gap-y-4" data-testid="signup-sent">
      <div className="flex flex-col gap-y-2">
        <h2 className="text-lg font-semibold">확인 메일을 보냈습니다</h2>
        <p className="text-sm text-secondary-foreground">
          <span className="font-medium text-foreground" data-testid="signup-sent-email">
            {email}
          </span>{" "}
          로 보낸 링크를 누르면 회사 정보 입력으로 이어집니다. 링크는 24시간 동안 쓸 수 있습니다.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button data-testid="signup-resend" disabled={pending || left > 0} onClick={resend} type="button" variant="outline">
          {pending ? "보내는 중…" : resendLabelOf(left)}
        </Button>
        {onChangeEmail && (
          <Button data-testid="signup-change-email" onClick={onChangeEmail} type="button" variant="ghost">
            메일 주소 바꾸기
          </Button>
        )}
      </div>
      <p className="text-xs text-muted-foreground" data-testid="signup-sent-note">
        메일이 오지 않으면 스팸함을 확인해 주세요. 이미 가입된 이메일이면 확인 메일 대신 로그인 안내 메일이 갑니다.
      </p>
    </div>
  );
};

export default SignupSent;
